import { Phone, MessageSquare, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND, REP_NAME, PHONE, PHONE_TEL, EMAIL } from "@/lib/constants";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-slate-800 bg-slate-950">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-12">
      <div>
        <div className="font-display font-black uppercase text-xl tracking-tight text-white">
          {BRAND}
        </div>
        <div className="text-xs uppercase tracking-[0.25em] text-red-600 mt-1">
          {REP_NAME} · Sales & Storm Specialist
        </div>
        <p className="text-slate-400 text-sm mt-5 max-w-xs leading-relaxed">
          Free roof inspections for wind, hail, and tree damage across metro Atlanta. Insurance-claim experienced.
        </p>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-red-600 mb-4">Contact</div>
        <ul className="space-y-3 text-sm">
          <li>
            <a data-testid="footer-call" href={`tel:${PHONE_TEL}`} className="inline-flex items-center gap-2 text-white hover:text-red-600">
              <Phone size={14} /> {PHONE}
            </a>
          </li>
          <li>
            <a data-testid="footer-text" href={`sms:${PHONE_TEL}`} className="inline-flex items-center gap-2 text-white hover:text-red-600">
              <MessageSquare size={14} /> Text {PHONE}
            </a>
          </li>
          <li>
            <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="inline-flex items-center gap-2 text-white hover:text-red-600 break-all">
              <Mail size={14} /> {EMAIL}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-red-600 mb-4">Site</div>
        <ul className="space-y-3 text-sm">
          <li><Link to="/" className="text-white hover:text-red-600">Home</Link></li>
          <li><Link to="/shingles" className="text-white hover:text-red-600">Shingle Samples</Link></li>
          <li><Link to="/#inspect" className="text-white hover:text-red-600">Schedule Inspection</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between text-xs text-slate-500 gap-2">
        <span>© {new Date().getFullYear()} {BRAND}. All rights reserved.</span>
        <span>Servicing Georgia · Free inspections · Licensed & insured roofing pro.</span>
      </div>
    </div>
  </footer>
);
